import axios from 'axios'
import { getAxiosOptionsURL } from 'common/functions'
import { API } from 'src/common/api-service/API'
import { UZBEK_CYRILLIC_ENABLED, normalizeLocalizedData } from 'src/common/utils/locale'

const axiosOptions = getAxiosOptionsURL()

export let ApiServiceMain
export default ({ app }) => {
  const axiosInstance = axios.create(axiosOptions)

  if (UZBEK_CYRILLIC_ENABLED) {
    axiosInstance.interceptors.response.use(
      (response) => {
        if (response?.data) {
          response.data = normalizeLocalizedData(response.data)
        }
        return response
      },
      (error) => {
        if (error?.response?.data) {
          error.response.data = normalizeLocalizedData(error.response.data)
        }
        return Promise.reject(error)
      },
    )
  }

  const instance = new API(axiosInstance)

  ApiServiceMain = instance
  app.config.globalProperties.$axios = instance
}
